import React, { useEffect, useRef } from 'react'
import * as d3 from 'd3'
import { useElementSize } from '../hooks'

export const PieChart = ({
  data,
  donut,
}: {
  data: IPieChartData[]
  donut?: boolean
}) => {
  const [wrapperRef, width, height] = useElementSize()
  const ref = useRef(null)
  const cache = useRef(data)
  const size = Math.min(width, height)
  const radius = size / 2
  const createPie = d3.pie<IPieChartData>().value((d) => d.value).sort(null)
  const createArc = d3.arc().innerRadius(donut ? radius / 3 : 0).outerRadius(radius)
  const colors = d3.scaleOrdinal(d3.schemeCategory10)

  useEffect(() => {
    if (!size) { return }
    const newData = createPie(data)
    const prevData = createPie(cache.current)
    const group = d3.select(ref.current)
    const groupWithData = group.selectAll('g.arc').data(newData)
    groupWithData.exit().remove()

    const groupWithUpdate = groupWithData.enter().append('g').attr('class', 'arc')
    const path = groupWithUpdate.append('path').merge(groupWithData.select('path.arc'))
    const arcTween = (d: any, i: any) => {
      const interpolar = d3.interpolate(prevData[i], d)
      return (t: any) => createArc(interpolar(t))
    }

    path.attr('class', 'arc').attr('fill', (d, i) => colors(i as any)).transition().attrTween('d', arcTween as any)
    const text = groupWithUpdate.append('text').merge(groupWithData.select('text'))
    text
      .attr('text-anchor', 'middle')
      .attr('aligment-baseline', 'middle')
      .style('fill', 'white')
      .style('font-size', '10')
      .transition()
      .attr('transform', d => `translate(${createArc.centroid(d as any)})`)
      .tween('text', (d, i, nodes) => {
        // const interpolator = d3.interpolate(prevData[i], d)
        return () => d3.select(nodes[i]).text(data[i].label)
      })

    cache.current = data
  }, [data, wrapperRef.current])

  return <svg ref={wrapperRef} style={{ width: '100%', height: '100%' }}>
    <g ref={ref} transform={`translate(${width / 2}, ${height / 2})`} />
  </svg>
}

export interface IPieChartData {
  label: string
  value: number
}
